import VwKimlikDTO from "src/models/Genel/VwKimlikDTO";
import api from "src/services/core/api";

const controllerName = "VwKimlikDTO";
export const kimlikApi = api.injectEndpoints({
  //bütünü bir objedir
  //endpoint bir ropertdir
  //builder fonkdur
  endpoints: builder => ({
    //GetOnlyBySearchText: This is the name of the endpoint. It represents the operation you want to 
    //perform, which in this case is fetching data using the GET method.
    GetOnlyBySearchText: builder.mutation<Array<VwKimlikDTO>, string>({
      query: (searchText) => ({
        //getonlybysearchtext nerden geliyor? bu path neresi
        url: controllerName + "/GetOnlyBySearchText",
        method: "GET",
        params: {
          searchText
        }
        //In summary, this code sets up an API endpoint called GetOnlyBySearchText that can be used 
        //to fetch data from the server using the GET method. It's part of the kimlikApi configuration, 
        //which can be used with rtk-query to handle data fetching and caching in your Redux application.
      })
    })
  }),
})

export const { useGetOnlyBySearchTextMutation } = kimlikApi;